import { useLayoutEffect, useRef } from 'react';

export const useLatest = <T = any>(value: T) => {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  });

  return ref;
};

export default useLatest;
